<div class="tt">
  <!-- Search and sort -->
  <div class="tt__toolbar">
    <app-search-input
      class="tt__search"
      placeholder="Search templates by name"
      [debounce]="300"
      (valueChange)="handleValueChange($event)"
    />
    <app-sort-dropdown
      [groups]="sortGroups"
      [selectedValue]="sortValue"
      (selectionChange)="handleSortChange($event)"
    />
  </div>

  <!-- Templates -->
  <div class="bk-panel tt__panel">
    <data-table label="Message templates" [seamless]="true" [loading]="isLoading && !rows.length" [maxHeight]="'600px'" [skeletonColumns]="5">
      @if (serverMode && serverError) {
        <div class="tt__state">
          <p>{{ serverError }}</p>
          <button type="button" class="bk-btn bk-btn--ghost" (click)="runSearch(currentPage)">Try again</button>
        </div>
      } @else if (rows.length) {
        <table class="bk-log" [class.is-loading]="isLoading">
          <thead>
            <tr>
              <th scope="col">Template</th>
              <th scope="col" class="col-category">Category</th>
              <th scope="col" class="num col-parts">Parts</th>
              <th scope="col" class="col-created">Created</th>
              <th scope="col" class="col-actions"><span class="bk-sr-only">Actions</span></th>
            </tr>
          </thead>
          <tbody>
            @for (row of rows; track row.key) {
              <tr>
                <td class="col-msg">
                  <span class="bk-msg">
                    <span class="bk-msg__subject">{{ row.name }}</span>
                    <span class="bk-msg__preview">
                      @if (row.copy) {
                        <bk-sms-text [text]="row.copy" [inline]="true" />
                      } @else {
                        <span class="tt__no-copy">No text</span>
                      }
                    </span>
                  </span>
                </td>
                <td class="quiet col-category">{{ row.category }}</td>
                <td class="num quiet col-parts" [attr.title]="row.partsHint">
                  {{ row.parts }}
                  @if (row.partsHint) {
                    <span class="bk-sr-only">. {{ row.partsHint }}</span>
                  }
                </td>
                <td class="quiet col-created">{{ row.created }}</td>
                <td class="col-actions">
                  <span class="bk-row-actions">
                    <ng-container
                      *hasPermission="{ category: 'MESSAGE_CONTENT_MANAGEMENT', permission: 'compose-sms' }"
                    >
                      <button
                        type="button"
                        class="bk-icon-btn"
                        [attr.aria-label]="'Use ' + row.name + ' in a new message'"
                        matTooltip="Use in a message"
                        (click)="openEditContact(row.template)"
                      >
                        <span class="bk-sym" aria-hidden="true">send</span>
                      </button>
                    </ng-container>
                    <ng-container
                      *hasPermission="{ category: 'MESSAGE_CONTENT_MANAGEMENT', permission: 'edit-message-templates' }"
                    >
                      <button
                        type="button"
                        class="bk-icon-btn"
                        [attr.aria-label]="'Edit ' + row.name"
                        matTooltip="Edit template"
                        (click)="viewTemplate(row.template)"
                      >
                        <span class="bk-sym" aria-hidden="true">edit</span>
                      </button>
                    </ng-container>
                    <ng-container
                      *hasPermission="{ category: 'MESSAGE_CONTENT_MANAGEMENT', permission: 'delete-message-templates' }"
                    >
                      <button
                        type="button"
                        class="bk-icon-btn"
                        [attr.aria-label]="'Delete ' + row.name"
                        matTooltip="Delete template"
                        (click)="openPrompt(row.template)"
                      >
                        <span class="bk-sym" aria-hidden="true">delete</span>
                      </button>
                    </ng-container>
                  </span>
                </td>
              </tr>
            }
          </tbody>
        </table>
      } @else {
        <app-empty-state
          [icon]="searchValue.trim() ? 'search' : 'messages'"
          [message]="
            searchValue.trim()
              ? 'No templates match “' + searchValue.trim() + '”. Try a shorter name.'
              : 'No templates yet. Choose New template to save copy you send often.'
          "
          size="medium"
        />
      }
    </data-table>
  </div>

  <!-- Pagination -->
  <div class="tt__pagination">
    <app-pagination
      (onPrev)="handlePrev()"
      (onNext)="handleNext()"
      (changePage)="handleChangePage($event)"
      (pageSizeChange)="handlePageSizeChange($event)"
      [currentPage]="currentPage"
      [totalPages]="totalPages"
      [totalItems]="totalItems"
      [pageSize]="pageSize"
      [loading]="isLoading"
    ></app-pagination>
  </div>

  <app-prompt-card
    buttonText="Delete"
    title="Delete template"
    closeText="Keep template"
    [openModal]="showDeletePrompt"
    (onClose)="closeDeletePrompt()"
    (onButtonClick)="deleteContact()"
    [loading]="loading"
  >
    <div class="description">
      Delete <span class="font-bold">{{ selectedTemplate.name || "this template" }}</span>? It leaves your template list.
      Messages already sent keep their text.
    </div>
  </app-prompt-card>
</div>
